import { render } from "./TransactionItem.vue?vue&type=template&id=ae7c34a6&scoped=true"
import script from "./TransactionItem.vue?vue&type=script&lang=js"
export * from "./TransactionItem.vue?vue&type=script&lang=js"

import "./TransactionItem.vue?vue&type=style&index=0&id=ae7c34a6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae7c34a6"]])

export default __exports__